import type { AiPicture } from '~~/domains/graphql';

type Transformation = {
  w?: number;
  h?: number;
  fit?: 'pad' | 'fill' | 'scale' | 'crop' | 'thumb';
};

export function useGalleryToImageProps(
  galleryImages?: AiPicture[] | undefined | null,
  transformation: Transformation = { fit: 'fill' },
): AiImageProps[] {
  if (
    !galleryImages ||
    !Array.isArray(galleryImages) ||
    galleryImages.length <= 0
  )
    return [];

  if (
    !galleryImages ||
    !Array.isArray(galleryImages) ||
    galleryImages.length <= 0
  )
    return [];

  const queryParams = Object.entries(transformation)
    .map(([property, value]) => `${property}=${value}`)
    .join('&');

  return galleryImages.map(image => ({
    alt: image.alt ?? '',
    src: `${image?.src}?${queryParams}`,
    srcSet: image.srcSet as string,
  }));
}
